import { ChangeEvent } from 'react';
import { Input } from '../../../components/Input';

interface Props {
  ticketFields: any;
  loading: boolean;
  onChange(event: ChangeEvent<HTMLInputElement>): void;
}

export const TicketContactInformation = ({
  ticketFields,
  loading,
  onChange,
}: Props) => (
  <div className="grid grid-cols-12 gap-2">
    <Input
      name="name"
      className="col-span-full sm:col-span-7"
      color="primary"
      type="text"
      fullWidth
      placeholder="Name"
      helperText="*Required"
      required
      value={ticketFields.name}
      onChange={onChange}
      variant="contained"
      disabled={loading}
    />

    <Input
      name="phone"
      className="col-span-full sm:col-span-5"
      color="primary"
      type="text"
      fullWidth
      placeholder="Phone Number"
      value={ticketFields.phone}
      onChange={onChange}
      variant="contained"
      disabled={loading}
    />
  </div>
);
